import { z } from 'zod/v4';

const phoneE164 = z.string().regex(/^\+?\d{10,15}$/, 'Telefone inválido');

export const comercialSchema = z.object({
    name: z.string().min(3),
    last_name: z.string().min(3),
    email: z.email(),
    // phone: z.string().regex(/^\(?\d{2}\)?[\s.-]?\d{4,5}[\s.-]?\d{4}$/), # OLD
    phone: phoneE164,
    company_name: z.string().min(3),
    department: z.string().min(3),
    subject: z.string().min(3),
    message: z.string().min(3),
    cnpj: z.string().regex(/^\d{2}[\s./-]?\d{3}[\s./-]?\d{3}[\s./-]?\d{4}[\s./-]?\d{2}$/),
});

export type comercialFormDataType = z.infer<typeof comercialSchema>;

export const sacSchema = z.object({
    name: z.string().min(3),
    last_name: z.string().min(3),
    title: z.string().min(3),
    email: z.email(),
    // phone: z.string().optional(), # OLD
    phone: phoneE164.optional(),
    category: z.string().min(3),
    message: z.string().min(3),
    type: z.string().min(3),
});

export type sacFormDataType = z.infer<typeof sacSchema>;
